import React, { useState, useRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Dialog from "../elements/Dialog";
import Button from "../elements/Button";
import Notice from "../elements/Notice";
import Billboard from "../Billboard";

const CustomTextField = withStyles({
  root: {
    backgroundColor: "#ffffff",
    borderRadius: 8,
    "& label.Mui-focused": {
      color: "#3D71FF",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      "& fieldset": {
        borderColor: "#DEE7EE",
      },
      "&:hover fieldset": {
        borderColor: "#DEE7EE",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#3D71FF",
      },
    },
  },
})(TextField);

const TwoFactor = (props) => {
  const [emailAuth, setEmailAuth] = useState(false);
  const [showResetAuthModal, setShowResetAuthModal] = useState(false);

  const authResetRequestFormRef = useRef();

  const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const getActionLink = () => {
    if (emailAuth) {
      return `/organization/${props.org_id}/verifyemailtoken`;
    }

    if (props.otp_secret) {
      return `/organization/${props.org_id}/createtwofactor`;
    } else {
      return `/organization/${props.org_id}/verifytwofactor`;
    }
  };

  const renderTitle = () => {
    if (emailAuth) {
      return (
        <React.Fragment>
          <h1 style={{ marginBottom: "0.5rem", fontWeight: "bold", whiteSpace: "nowrap" }}>
            Enter Email Code
          </h1>
          <p className="t--subtitle" style={{ marginBottom: "1rem" }}>
            Enter the code sent to your email.
          </p>
        </React.Fragment>
      );
    }

    if (props.otp_secret) {
      return (
        <React.Fragment>
          <h1 style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>Set Up Authenticator</h1>
          <p className="t--subtitle" style={{ marginBottom: "1rem" }}>
            Scan the QR code with your choice of authenticator.
          </p>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <h1 style={{ marginBottom: "0.5rem", fontWeight: "bold", whiteSpace: "nowrap" }}>
            Enter Authenticator Code
          </h1>
          <p className="t--subtitle" style={{ marginBottom: "1rem" }}>
            Enter the code from your authenticator.
          </p>
        </React.Fragment>
      );
    }
  };

  const renderForm = () => {
    return (
      <div className="auth__form">
        <img src={props.mfr_logo} style={{ width: 150, marginBottom: 30 }} />

        {renderTitle()}
        <form method="POST" action={getActionLink()} className="authentication__form">
          <div className="">
            <img src={props.qr_code} style={{ textAlign: "center" }} />
            <input type="hidden" id="token" name="otp_secret" value={props.otp_secret} />
            <CustomTextField
              label="Authenticator Code"
              margin="normal"
              variant="outlined"
              id="code"
              name="otp_attempt"
              fullWidth
              required
              autoFocus
            />
          </div>
          <div className="auth__form__footer">
            <div className="auth__form_button_row" style={{ display: "flex", gap: "1em" }}>
              <a href="/logout">
                <button
                  className="btn btn--light-big"
                  style={{ flexGrow: 1, alignSelf: "inherit" }}
                  type="button"
                >
                  LOGOUT
                </button>
              </a>
              <button className="btn" style={{ flexGrow: 2, alignSelf: "inherit" }} type="submit">
                SUBMIT
              </button>
            </div>
          </div>
        </form>
        {props.user_active && (
          <form
            method="POST"
            action={`/organization/${props.org_id}/request_two_factor_reset`}
            style={{ marginTop: 20 }}
            ref={authResetRequestFormRef}
          >
            <input type="hidden" name="user_id" value={props.user_id} />
            <input type="hidden" name="authenticity_token" value={csrfToken} />
            <button type="button" onClick={() => setShowResetAuthModal(true)} style={{fontSize: 14}}>
              Request two-factor authentication reset?
            </button>
          </form>
        )}
      </div>
    );
  };

  const renderAuthModal = () => {
    return (
      <Dialog
        open={showResetAuthModal}
        setOpen={setShowResetAuthModal}
        title="Two-factor Authentication Reset"
        description="Are you sure you want to reset your two-factor authentication? We'll send the request to your team's admin. Your account will be disabled until your admin approves your two-factor authentication reset request."
        confirm={
          <Button
            onClick={() => authResetRequestFormRef.current.submit()}
            utilityClasses="ph--8 br--pill lh--tight flex--item-grow1"
          >
            Yes, Request Two-Factor Authentication Reset
          </Button>
        }
        cancel={
          <Button variant="secondary" utilityClasses="ph--24 br--pill lh--tight">
            Cancel
          </Button>
        }
      />
    );
  }

  return (
    <div className="auth__wrapper">
      <div className="auth__container">
        <Billboard />
        <div className="auth__container--form">{renderForm()}</div>
        {renderAuthModal()}
      </div>
    </div>
  );
};

export default TwoFactor;
